module.exports = __webpack_public_path__ + "static/media/dkle1.58f0193b.png";